<div id="questionContainer" class="questionContainer" data-question-container="all_at_once">
  <span class="loader">
    <span></span>
    <span></span>
    <span></span>
  </span>
</div>
